import React, { useEffect, useState } from "react";
import Select from "react-select";

const CountryOptions = ({ homePage = false, setFilter, selectedValue }) => {
    const [options, setOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);

    // Fetch states from API
    const fetchStates = async () => {
        const res = await fetch(
            "https://gist.githubusercontent.com/mshafrir/2646763/raw/states_titlecase.json"
        );
        const states = await res.json();
        const formatted = states.map((state) => ({
            value: state.abbreviation,
            label: state.name,
        }));
        setOptions(formatted);
    };

    useEffect(() => {
        fetchStates();
    }, []);

    // When options are loaded OR selectedValue changes -> set preselected option
    useEffect(() => {
        if (selectedValue && options.length > 0) {
            const match = options.find((opt) => opt.value === selectedValue || opt.label === selectedValue);
            if (match) {
                setSelectedState(match);
                if (homePage) {
                    setFilter((prev) => ({
                        ...prev,
                        state: match.value,
                    }));
                }
            }
        }
    }, [selectedValue, options]);

    // When user changes selection manually
    useEffect(() => {
        // if (!homePage) return;
        setFilter((prev) => ({
            ...prev,
            state: selectedState?.value || "",
        }));
    }, [selectedState]);

    const colourStyles = (homePage) => ({
        control: (base) => ({
            ...base,
            border: 0,
            boxShadow: "none",
            padding: "12px 0 12px 35px",
            margin: "-16px 0 0 -45px",
            borderRadius: "0",
            ...(!homePage && {
                outline: "none",
                backgroundColor: "transparent",
                padding: "18px 0px 30px 35px",
            }),
        }),
        placeholder: (styles) => ({
            ...styles,
            fontSize: "14px",
            color: "#888",
        }),
    });

    return (
        <React.Fragment>
            <Select
                options={options}
                className="choices selectForm__inner"
                styles={colourStyles(homePage)}
                value={selectedState}
                onChange={setSelectedState}
                placeholder="Search or select a state..."
                isSearchable
            />
        </React.Fragment>
    );
};

export default CountryOptions;
